import {prefix} from './../config';

export const UPDATE = prefix + 'UPDATE';

export const IS_OK = prefix + 'IS_OK';

export const update = (updateOb) => ({type: UPDATE, updateOb});

export const isOk = () => ({type: IS_OK});